module.exports = __webpack_public_path__ + "static/media/route-pro-badge-sm.be299097.svg";